import { render, staticRenderFns } from "./form-for-bank-employee.vue?vue&type=template&id=52561fec"
import script from "./form-for-bank-employee.vue?vue&type=script&lang=js"
export * from "./form-for-bank-employee.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports